import { render, staticRenderFns } from "./alertconfiglist.vue?vue&type=template&id=090e8288&scoped=true&"
import script from "./alertconfiglist.vue?vue&type=script&lang=js&"
export * from "./alertconfiglist.vue?vue&type=script&lang=js&"
import style0 from "./alertconfiglist.vue?vue&type=style&index=0&id=090e8288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090e8288",
  null
  
)

export default component.exports